module.exports = __webpack_public_path__ + "static/img/2861_logo.0848dd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/2861_logo.png
// module id = zm3M
// module chunks = 0